import { render, staticRenderFns } from "./NumeroSerie.vue?vue&type=template&id=2dd80afa&scoped=true"
import script from "./NumeroSerie.vue?vue&type=script&lang=js"
export * from "./NumeroSerie.vue?vue&type=script&lang=js"
import style0 from "./NumeroSerie.vue?vue&type=style&index=0&id=2dd80afa&prod&lang=stylus&scoped=true"
import style1 from "./NumeroSerie.vue?vue&type=style&index=1&id=2dd80afa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dd80afa",
  null
  
)

export default component.exports